import React from 'react';
import { Provider } from 'react-redux';
import Loadable from 'react-loadable';

import createStore from '../redux/store';
import Loading from 'lib/components/Loading'; // eslint-disable-line

const CreateStripeAccountContainer = Loadable({
  loader: () => import('../containers/CreateStripeAccountContainer'),
  loading: Loading,
});

export default props => {
  const store = createStore(props);
  const reactComponent = (
    <Provider store={store}>
      <CreateStripeAccountContainer />
    </Provider>
  );
  return reactComponent;
};
